export class DeviceTokenService {

    /* @ngInject */
    constructor($cookies) {
        this.$cookies = $cookies;
    }

    createCookie(userDetails, uuid){
        var deviceTokens = {};
        var expireDate = new Date();
        expireDate.setDate(expireDate.getYear() + 1);
        var currentDeviceTokens = this.$cookies.getObject("x-egto-device-token-id");
        deviceTokens = [{
            userId: userDetails.id,
            deviceTokenId: uuid
        }];
        currentDeviceTokens = this.filterCookies.call(this, currentDeviceTokens, deviceTokens, userDetails);
        this.$cookies.put("x-egto-device-token-id", JSON.stringify(currentDeviceTokens), {'expires': expireDate});

    }

    filterCookies(currentDeviceTokens, deviceTokens, userDetails ) {
        if (currentDeviceTokens) {
            currentDeviceTokens.forEach((token, index) => {
                if (token.userId === userDetails.id) {
                    currentDeviceTokens.splice(index, 1);
                }
            });
            currentDeviceTokens.push(deviceTokens[0]);
        } else {
            currentDeviceTokens = deviceTokens;
        }
        return currentDeviceTokens;
    }
}
